import { useState } from 'react';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DeleteModal from './modals/DeleteModal';
import SynonymSetModal from './modals/SynonymSetModal';

const SynonymSetActions = ({ set, handleEdit, handleDelete }) => {
  const { t } = useTranslation();

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  // Open and close edit modal
  const openEditModal = () => setEditModalOpen(true);
  const closeEditModal = () => setEditModalOpen(false);

  // Open and close delete modal
  const openDeleteModal = () => setDeleteModalOpen(true);
  const closeDeleteModal = () => setDeleteModalOpen(false);

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton
          onClick={openEditModal}
          size="large"
          title={t('edit', { ns: 'buttons' })}
          aria-label="edit"
        >
          <Tooltip title={t('edit', { ns: 'buttons' })}>
            <EditIcon />
          </Tooltip>
        </IconButton>
        <IconButton
          onClick={openDeleteModal}
          size="large"
          title={t('delete', { ns: 'buttons' })}
          aria-label="delete"
        >
          <Tooltip title={t('delete', { ns: 'buttons' })}>
            <DeleteForeverIcon color="error" />
          </Tooltip>
        </IconButton>
      </Box>

      {/* Modals */}
      <SynonymSetModal
        open={editModalOpen}
        handleClose={closeEditModal}
        handleEdit={handleEdit}
        set={set}
      />

      <DeleteModal
        open={deleteModalOpen}
        handleClose={closeDeleteModal}
        id={set.id}
        handleDelete={handleDelete}
        isSynonymSet
      />
    </>
  );
};

SynonymSetActions.propTypes = {
  set: PropTypes.shape({
    id: PropTypes.string.isRequired,
    comment: PropTypes.string,
    items: PropTypes.array,
  }),
  handleEdit: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default SynonymSetActions;
